import { useEffect, useState } from "react";
import { IResponsiveObjectSchema } from "../../config/interfaces";
import { useWindowSize } from "@uidotdev/usehooks";
import { BREAKPOINTS } from "../../services/theme";

export const useResponsiveObject = <T>(
  responsiveSchema: IResponsiveObjectSchema<T>
): T | null => {
  const [state, setState] = useState<T | null>(null);
  const { width } = useWindowSize();

  useEffect(() => {
    if (
      !responsiveSchema ||
      (Array.isArray(responsiveSchema) && responsiveSchema.length === 0)
    ) {
      setState(null);
    }
    if (!Array.isArray(responsiveSchema)) {
      setState(responsiveSchema);
    } else {
      if (!width) return;

      // Ordina l'array in base ai breakpoint
      const sortedSchema = responsiveSchema.sort((a, b) => {
        const indexOfA = a.breakpoint
          ? Object.keys(BREAKPOINTS).indexOf(a.breakpoint)
          : 0;
        const indexOfB = b.breakpoint
          ? Object.keys(BREAKPOINTS).indexOf(b.breakpoint)
          : 0;
        return indexOfA - indexOfB;
      });

      // Trova il primo schema che soddisfa il breakpoint
      // Scorri i breakpoint partendo dal più grande
      for (let i = sortedSchema.length - 1; i >= 0; i--) {
        const schema = sortedSchema[i];
        if (
          !schema.breakpoint ||
          width >= (BREAKPOINTS as { [key: string]: number })[schema.breakpoint]
        ) {
          setState(schema.value);
          return;
        }
      }
    }
  }, [responsiveSchema, width]);

  return state;
};
